import { Injectable } from "@angular/core";

import { HttpClient } from '@angular/common/http';

import { BackendDataService } from '../../services/backendDataService/backendDataService';





export class BieffeModel{
  modelId:string;
  sfId:string;
  skus:Array<BieffeSku>;
  img?:string;
  modelData?:any;
  LEN?:Array<BieffeNode>;
  TEM?:Array<BieffeNode>;

}
export class BieffeSku{
  skuId:string;
  nodes:Array<BieffeNode>;
  
}
export class BieffeNode{
  nodeId:string;
  materialId:string;
  channels:any;
  skuIds?:Array<string>;
  texture?:{
    1024?:string,
    2048?:string,
    4096?:string,
  };
  uid?:{
    1024?:string,
    2048?:string,
    4096?:string,
  };
}

export class ConfiguratorOutput{
  modelId:string;
  modelData?:any;
  skuIds?:Array<string>;
}

export class ConfiguratorParams {
  salesOrg: string;
  distrCh: string;
  countryCode: string;
  username:string;
  serviceUrl:string;
  sketchfabDataUrl:string;
  imageUrl:string;
  showError: (message:string)=>any;
  onConfirm: (out:ConfiguratorOutput)=>any;
  
}

@Injectable()
export class ConfiguratorModel {

  imgPath: string;
  models: Array<BieffeModel>;
  params:ConfiguratorParams;
  semaforoError: any;

  constructor(private http: HttpClient, public backend: BackendDataService, ) { 
  }

  loadData(params:ConfiguratorParams){
    this.params=params;
    console.log(params);
    return this.loadBieffeData().then(()=>{
      this.models.forEach((m:BieffeModel)=>{
        this.loadModelData(m);

      })
    })
  }

  loadModelData(model:BieffeModel){

    this.request("models/list",{
      filter:{
        salesOrg: this.params.salesOrg,
        distrCh:this.params.distrCh,
        countryCode:this.params.countryCode,
        brands:['CTR']

      },
      search:model.modelId,
      username:this.params.username,
      offset:0,
      limit:1,


    }).then((data)=>{
      model.modelData=data.length?data[0]:{};
      let smallImage = "assets/image/no_image.png";
      if(data.length && data[0].images && data[0].images.cat && data[0].images.cat.xxl && data[0].images.cat.xxl.filename) {
        smallImage = this.params.imageUrl+data[0].images.cat.xxl.filename;
      }
      else if(data.length &&  data[0].images && data[0].images.front && data[0].images.front.xxl && data[0].images.front.xxl.filename) {
        smallImage = this.params.imageUrl+data[0].images.front.xxl.filename;
      }
      model.img=smallImage;
     

    })

  }

  loadBieffeData() {
    return new Promise((resolve, reject) => {
      let request = this.http
        .get(
          this.params.sketchfabDataUrl

        )
        .subscribe(
          (json: any) => {
            this.imgPath=json.imgPath;
            this.models=json.models;
            this.models.forEach((model)=>{
              model.LEN=[];
              model.TEM=[];
              model.skus.forEach((sku:BieffeSku)=>{
                sku.nodes.forEach((node:BieffeNode)=>{
                  
                  var finded= model[node.nodeId].find((n)=>{
                    return node.materialId==n.materialId
                  })
                  if(!finded)
                  {
                    node.skuIds=[sku.skuId];
                    var dummy= node.materialId=='SMOKE'?'https://i.ibb.co/N3KVQ1G/CT0147-S-002-Glass-Diffuse-powder-rose.jpg':"https://i.ibb.co/njkn0Pf/GG0972-S-SKU3-albedo.jpg"
                    node.texture={
                      1024:this.imgPath+"1024/"+node.channels["AlbedoPBR"],
                      2048:this.imgPath+"2048/"+node.channels["AlbedoPBR"],
                      //4096:this.imgPath+"4096/"+node.channels["AlbedoPBR"]
                      //1024:dummy,
                      //2048:dummy,
                      4096:this.imgPath+"4096/"+node.channels["AlbedoPBR"]
                    }
                    model[node.nodeId].push(node);
                  }
                  else
                  {
                    finded.skuIds.push(sku.skuId)
                  }
                  
                })
              })
            })
            console.log(this.models);
            resolve(json);
          },
          (error: any) => {

            reject(error);
          },
          () => {
            request.unsubscribe();
          }
        );
    });
  }


  request(requestUrl, filter):Promise<any>{

    let url = this.params.serviceUrl + "/"+requestUrl
    return new Promise((resolve,reject) => {
      let request = this.http
      .post(
        url,
        filter,
        {
          headers: {  "Accept": "*/*", "Content-Type": "application/json", 'Authorization': `Basic ` + btoa('kevsuser:Kvs2020!') } 
        },
      )
      .subscribe(
        (success:any) => {
          resolve(success);
        },
        (error:any) => {
        
            
            this.manageError(error, requestUrl);
          
          
          reject(error);
        },
        () => {
          request.unsubscribe();
        }
      );
    });
  }

  manageError(error, serviceUrl)
  {
    if(this.semaforoError)
        return;
    this.semaforoError=true;
    setTimeout(()=>{
      this.semaforoError=false;
    }, 1000)
    var message=`[${error.status}] An error has occurred. Please try again. (Service: ${serviceUrl})`;
    if(error.status==0)
    message ="Service unreachable. Please check your connection and try again."
    if(this.params.showError)
      this.params.showError(message);
  }

}
